// extracted by mini-css-extract-plugin
module.exports = {"templateTabs":"Templates_templateTabs__1R1xP","templatesConfigPanel":"Templates_templatesConfigPanel__3gUdG","search":"Templates_search__2BShb"};